import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import orderBy from 'lodash/orderBy';
import VerbTable from '../../../../../shared/components/VerbTable';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';

const TeamTooltip = <Tooltip id={'default-team-tooltip'}>Default Team</Tooltip>;
const TeamPopover = () => (
    <OverlayTrigger placement={'right'} transition={false} overlay={TeamTooltip}>
        <i className={'team-table-popover fal fa-info-circle'} />
    </OverlayTrigger>
);

const teamRow = (props) => {
    const {
        team: {
            _id,
            name,
            createdOn,
            members,
            isActive,
            isDefaultTeam = false,
            revision,
            parentId,
            isMultiCompany = false,
            permalink,
            featuredCollectionInfo,
            currentAssignedPathway
        },
        onEdit,
        deleteTeam,
        hasMultiCompanyTeam = false,
        pathwaysById,
        collectionsById,
        isVerbAdmin
    } = props;

    const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' };
    let date = new Date(createdOn);
    date = date.toLocaleDateString('en-US', dateOptions);
    const registeredMembers = members && members.filter((member) => member.isRegistered);

    const getFeaturedContentText = (_id) => {
        const defaultElem = (
            <div className={'featured-content-container'}>
                <p>No Featured Content</p>
                <p>
                    (Manage{' '}
                    {/* <Link
                        className={'verb-link'}
                        to={`/managepathways/${
                            isVerbAdmin ? 'showntoall' : 'exclusivecompanylicense'
                        }`}
                    >
                        Pathways
                    </Link>{' '}
                    or{' '} */}
                    <Link to={`/teams/${_id}`} className={'verb-link'}>
                        Featured Path
                    </Link>
                    )
                </p>
            </div>
        );
        if (
            currentAssignedPathway &&
            currentAssignedPathway.pathwayId &&
            pathwaysById[currentAssignedPathway.pathwayId]
        ) {
            return (
                <p className={'featured-content-container'}>
                    Pathway:{' '}
                    <Link
                        className={'verb-link'}
                        to={`/editpathway/${currentAssignedPathway.pathwayId}`}
                    >
                        {pathwaysById[currentAssignedPathway.pathwayId]?.name || currentAssignedPathway.pathwayName}
                    </Link>
                </p>
            );
        }
        if (
            isActive,
            featuredCollectionInfo &&
            featuredCollectionInfo.collectionId &&
            collectionsById[featuredCollectionInfo.collectionId]
        ) {
            return (
                <p className={'featured-content-container'}>
                    Path:{' '}
                    <Link to={`/teams/${_id}`} className={'verb-link'}>
                        {collectionsById[featuredCollectionInfo.collectionId]?.name}
                    </Link>
                </p>
            );
        }
        if (!isActive) {
            return (
                <div className={'featured-content-container'}>
                <p>Cannot feature content until team is active.</p>
            </div>
            )
        }
        return defaultElem;
    };

    return (
        <tr key={_id}>
            <td className={'buttonCell'}>
                <VerbButton
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    fontAwesomeIcon={'fa-pencil'}
                    type={'button'}
                    onClick={() => onEdit(_id)}
                />
                {!isDefaultTeam ? (
                    <VerbButton
                        id={'deleteTeamButton'}
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                        fontAwesomeIcon={'fa-trash'}
                        type={'button'}
                        onClick={() => {
                            deleteTeam(_id, {
                                name,
                                createdOn,
                                members,
                                isActive,
                                isDefaultTeam: false,
                                revision,
                                parentId,
                                permalink
                            });
                        }}
                    />
                ) : null}
            </td>
            <td>
                <div className={'team-name'}>
                    {name}
                    {isDefaultTeam ? <TeamPopover /> : null}
                </div>
            </td>
            <td className={'active-check left'}>{isActive ? <i className={'fas fa-check-circle'} /> : null}</td>
            <td>{date}</td>
            {hasMultiCompanyTeam && (
                <td className={'active-check left'}>
                    {isMultiCompany ? <i className={'fas fa-check-circle'} /> : null}
                </td>
            )}
            <td className={'left'}>{registeredMembers && registeredMembers.length}</td>
            <td className={'left'}>{getFeaturedContentText(_id)}</td>
        </tr>
    );
};

teamRow.propTypes = {
    team: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
        createdOn: PropTypes.date,
        memberCount: PropTypes.number,
        isActive: PropTypes.bool,
        members: PropTypes.array,
        isDefaultTeam: PropTypes.bool,
        revision: PropTypes.number,
        parentId: PropTypes.string,
        isMultiCompany: PropTypes.bool,
        permalink: PropTypes.string
    }),
    onEdit: PropTypes.func,
    deleteTeam: PropTypes.func,
    hasMultiCompanyTeam: PropTypes.bool,
    isVerbAdmin: PropTypes.bool
};

export default class TeamsTable extends Component {
    static propTypes = {
        teams: PropTypes.array,
        onEdit: PropTypes.func,
        history: PropTypes.object,
        deleteTeam: PropTypes.func,
        isLoading: PropTypes.bool,
        pathwaysById: PropTypes.object,
        collectionsById: PropTypes.object,
        isVerbAdmin: PropTypes.bool
    };

    _renderTeamsTable = () => {
        const { teams = [], history, onEdit, deleteTeam, pathwaysById, collectionsById, isVerbAdmin } = this.props;
        const hasMultiCompanyTeam = teams.some((team) => team.isMultiCompany);
        const tableHeader = (
            <thead>
                <tr>
                    <th className={'adminAction left'}>Actions</th>
                    <th>Team Name</th>
                    <th className={'left'}>Active</th>
                    <th>Created</th>
                    <th className={'left full-col'}>Participants</th>
                    <th className={'left full-col'}>Featured Content</th>
                </tr>
            </thead>
        );
        const nameAccessor = (item) => (item.name && item.name.toLocaleUpperCase()) || '';
        return (
            <VerbTable className={'manage-table'} headerComponent={tableHeader} isHover>
                <tbody>
                    {(teams &&
                        teams.length ) ? 
                        orderBy(teams, [nameAccessor], ['asc']).map((team) =>
                            teamRow({
                                team,
                                history,
                                onEdit,
                                deleteTeam,
                                hasMultiCompanyTeam,
                                pathwaysById,
                                collectionsById,
                                isVerbAdmin
                            })
                        )
                        : null
                    } 
                </tbody>
            </VerbTable>
        );
    };

    render() {

        const { teams = [] } = this.props;
        if (!this.props.isLoading) {
            return <div className={'col-12 manage-teams-table'}>
                {this._renderTeamsTable()}
                {!teams.length ? (<div className={'no-teams-message'}>No teams have been created yet - select the '+ New Team' button above to create your first team!</div>)  : null}
                <div className='row'>
                    <div className='col-12 readmore knowledge-link'>
                        <p className='m-0 desc'>Learn more about Paths teams in our <a
                            href='https://knowledge.paycor.com/2604472-how-do-i-create-a-learning-group-or-team' target="_blank"
                            className='link'>Knowledge Base</a>.</p>
                    </div>
                </div>
            </div>;
        }
        return null;
    }
}
